import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import sortBy from 'lodash.sortby';
import { grantsScopedModule } from './usePermissions';
import { userCoversTeam } from './useInboxTeams';

const SCOPE_GLOBAL = 0;

const userCoversLocation = (user, locationId) => {
    if (user.isOwner) return true;

    return (user.teams || []).some(
        t => grantsScopedModule(t) && (t.scopeType === SCOPE_GLOBAL || t.locationIds?.includes(locationId)),
    );
};

export const useUsersOptions = () => {
    const users = useSelector(state => state.account?.account?.users || []);

    const mapUserPropsToOption = user => ({
        label: `${user.firstName} ${user.lastName}`,
        value: user.id,
        profileImageUrl: user.profileImageUrl,
    });

    const getUsersOptionsByLocationId = useCallback(
        (locationId, propsMapper = mapUserPropsToOption) => {
            return sortBy(users.filter(user => userCoversLocation(user, locationId)).map(propsMapper), 'label');
        },
        [users],
    );

    const getUsersOptionsByLocationIds = useCallback(
        (locationIds, propsMapper = mapUserPropsToOption) => {
            return sortBy(
                users.filter(user => locationIds.some(locId => userCoversLocation(user, locId))).map(propsMapper),
                'label',
            );
        },
        [users],
    );

    const getUsersOptionsByTeamId = useCallback(
        (teamId, propsMapper = mapUserPropsToOption) => {
            return sortBy(users.filter(user => userCoversTeam(user, teamId)).map(propsMapper), 'label');
        },
        [users],
    );

    return {
        getUsersOptionsByLocationId,
        getUsersOptionsByLocationIds,
        getUsersOptionsByTeamId,
    };
};
